import React from "react";
import FullScreenContainer from "components/common/FullScreenContainer";
import PropTypes from "prop-types";

const ErrorCode = props => {
    ErrorCode.propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                errorCode: PropTypes.string
            })
        }).isRequired
    };
    const content =
        props.match.params.errorCode === "NO_SESSION"
            ? "zuulError.content.nosession"
            : "zuulError.content.systemerror";
    const title =
        props.match.params.errorCode === "NO_SESSION"
            ? "NO SESSION"
            : "zuulError.title";
    return <FullScreenContainer content={content} title={title} />;
};

export default ErrorCode;
